export default [
    {
        name: 'cadastro-bairro',
        path: 'bairro',
        redirect: 'bairro/index',
        component: () => import(/* webpackChunkName: 'cadastro-bairro' */ '@/views/cadastro/bairro/Index'),
        children: [
            {
                meta: {title: 'Lista de bairros'},
                name: 'cadastro-bairro-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-bairro' */ '@/views/cadastro/bairro/List'),
            },
            {
                meta: {title: 'Cadastro de bairro'},
                name: 'cadastro-bairro-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-bairro' */ '@/views/cadastro/bairro/Form'),
            },
            {
                meta: {title: 'Edição de bairro'},
                name: 'cadastro-bairro-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-bairro' */ '@/views/cadastro/bairro/Form'),
            },
        ],
    },
]